<div class="map-container">
  <form [formGroup]="mapForm">
    <div>
      <div class="scroll-display" (scroll)="onScroll($event)">
        <div class="parent">
          <div class="map-input-container">
            <app-text-input
              [placeholder]="'Endereço da sua empresa'"
              [labelText]="'Endereço da sua empresa'"
              formControlName="locationStreet"
              [required]="true"
              [submitted]="submitted"
            ></app-text-input>
            <label *ngIf="directionWarning" class="warning-label"
              >Formato inválido, por ex. para entrar: "Honduras 123"
            </label>
            <div class="container-click" (keydown)="getAutomaticLocation()" (click)="getAutomaticLocation()">
              <mat-icon class="icon-gps">gps_fixed</mat-icon>
              <label class="input-label"> Minha localização atual</label>
            </div>
          </div>
          <div class="map-input-container-location-street">
            <app-text-input
              class="map-input-street-location"
              [placeholder]="'Nº'"
              [labelText]="'Nº'"
              [type]="'number'"
              [required]="true"
              formControlName="locationStreetNumber"
              [submitted]="submitted"
            ></app-text-input>
          </div>
        </div>
        <div class="parent">
          <div class="map-input-container-city">
            <app-text-input
              [placeholder]="'Cidade'"
              [labelText]="'Cidade'"
              formControlName="locationCity"
              [required]="true"
              [submitted]="submitted"
            ></app-text-input>
          </div>
          <div class="map-input-container-zip-code">
            <app-text-input
              [attr.data-testid]="'codigo-postal (05407-002)'"
              [placeholder]="'CEP'"
              [labelText]="'CEP'"
              formControlName="zipCode"
              [required]="true"
              [type]="'cp'"
              [submitted]="submitted"
            ></app-text-input>
          </div>
        </div>
        <div class="map-input-container">
          <app-text-input
            [placeholder]="'Estado'"
            [labelText]="'Estado'"
            formControlName="locationState"
            [required]="true"
            [submitted]="submitted"
          ></app-text-input>
        </div>
        <div class="map-input-container">
          <app-text-input
            class="map-input-street-location"
            [labelText]="'Complemento (opcional)'"
            [type]="'text'"
            [max]="10"
            formControlName="depto"
            [submitted]="this.mapForm.get('depto')?.value?.length > 10"
          ></app-text-input>
        </div>
        <div class="map-input-container">
          <app-text-input
            [labelText]="'Comentários adicionais (opcional)'"
            [type]="'text'"
            [max]="40"
            formControlName="entreCalles"
            [submitted]="this.mapForm.get('entreCalles')?.value?.length > 40"
          ></app-text-input>
        </div>
      </div>
    </div>
  </form>
</div>
